import {emitGeneralErrorToast} from '../toasts/toasts.utils';

export function handleGeneralError(error: Error) {
  console.error(error);
  emitGeneralErrorToast();
}
